module.exports = __webpack_public_path__ + "img/set-head.bffde66b.png";